import { render, staticRenderFns } from "./formBox.vue?vue&type=template&id=0268a546&scoped=true"
import script from "./formBox.vue?vue&type=script&lang=js"
export * from "./formBox.vue?vue&type=script&lang=js"
import style0 from "./formBox.vue?vue&type=style&index=0&id=0268a546&lang=scss&scoped=true"
import style1 from "./formBox.vue?vue&type=style&index=1&id=0268a546&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0268a546",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0268a546')) {
      api.createRecord('0268a546', component.options)
    } else {
      api.reload('0268a546', component.options)
    }
    module.hot.accept("./formBox.vue?vue&type=template&id=0268a546&scoped=true", function () {
      api.rerender('0268a546', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/assess/staff/components/formBox.vue"
export default component.exports